import dict from "../../Data/dict.json"
import icon_routing from "../../Assets/svg/icon_routing.svg"
import icon_grid_count_point from "../../Assets/svg/icon_grid_count_point.svg"
import icon_isochrone from "../../Assets/svg/icon_isochrone.svg"
import icon_radius from "../../Assets/svg/icon_radius.svg"
import icon_elevation from "../../Assets/svg/icon_elevation.svg"
import icon_distance from "../../Assets/svg/icon_distance.svg"
import icon_area from "../../Assets/svg/icon_area.svg"

export const get_toolbox_mode_list = (key) => {
  const language = localStorage?.language || "ina";
  const mode_list = [
    {
      key: "features_distance",
      name: dict["Distance"][language],
      mode: "draw_line_string",
      is_need_toolbox_companion: true,
      description: dict?.[
        "Measure the straight line distance between point A to point B or length of a line"
      ]?.[language],
      uuid_name: "uuid_distance",
      text_button: dict?.["Measure distance"]?.[language],
      name_id: "D-",
      unit_options: ["kilometer", "meter"],
      first_point: "Click on the map to choose your start location.",
      end_point: "Click for another point, then double-click to finish.",
      icon: icon_distance
    },
    {
      key: "features_elevation",
      name: dict["Elevation"][language],
      mode: "draw_line_string",
      is_need_toolbox_companion: true,
      description: dict?.[
        "Measure elevation samples of the cross section along the line"
      ]?.[language],
      uuid_name: "uuid_elevation",
      text_button: dict?.["Draw line elevation"]?.[language],
      is_need_setting: true,
      name_id: "E-",
      icon: icon_elevation
    },
    {
      key: "features_area",
      name: "Area",
      mode: "draw_polygon",
      is_need_toolbox_companion: true,
      description: dict?.[
        "Draw polygon and measure the area. Clip your data with polygon you draw. Only works with point type layers"
      ]?.[language],
      uuid_name: "uuid_area",
      text_button: dict?.["Measure area"]?.[language],
      unit_options: ["hectare", "meter_square"],
      name_id: "A-",
      first_point: "Click for another point, then double-click to finish.",
      end_point: "Click for another point, then double-click to finish.",
      icon: icon_area,
      is_area: true
    },
    {
      key: "features_radius",
      name: "Radius",
      is_need_toolbox_companion: true,
      mode: "draw_point",
      description: dict?.[
        "Draw a radius to measure distance and filter nearby data. Only works with point type layers."
      ]?.[language],
      unit_options: ["kilometer", "meter"],
      uuid_name: "uuid_radius",
      text_button: dict?.["Create buffer radius"]?.[language],
      name_id: "R-",
      is_need_setting: true,
      icon: icon_radius,
      is_area: true

    },
    {
      key: "features_isochrone",
      name: dict["Isochrone"][language],
      mode: "draw_point",
      description: dict["Calculate reachable areas based on travel time or distance from a specific point."]?.[language],
      is_need_toolbox_companion: true,
      uuid_name: "uuid_isochrone",
      text_button: "Isochrone", //dict?.["Isochrone"]?.[language],
      name_id: "I-",
      is_need_setting: true,
      unit_options: ["minute", "meter"],
      icon: icon_isochrone,
      is_area: true
    },
    {
      key: "scoring_grids",
      name: dict["Grid"][language],
      mode: "",
      is_need_toolbox_companion: false,
      icon: icon_grid_count_point,
    },
    {
      key: "features_routing",
      name: dict["Routing"][language],
      is_new: true,
      is_need_toolbox_companion: true,
      is_need_setting: true,
      icon: icon_routing,
      uuid_name: "uuid_routing",
      name_id: "Ro-",
      description: dict["Calculate route and distance from start to destination."]?.[language],
      mode: "draw_point",
    }
  ];

  let result = [];
  if (key) result = mode_list.find(m => m.key === key)
  else result = mode_list;

  return result
}